export function setLazyLoadingOnIframe(iframeCode: string) {
  if (/\bloading\s*=/.test(iframeCode)) {
    return iframeCode
  }
  return iframeCode.replace(/(<iframe\b[^>]*?)\bsrc=/, '$1loading="lazy" src=')
}
